import { Environment } from '@/config';

export const isInLowerEnv = () => {
  const env = window.lio.getApiEnvironment();

  // do not show in UAT or PROD
  return [Environment.Local, Environment.Dev, Environment.Int, Environment.QA].includes(env);
};

export const isNotProduction = () => {
  const env = window.lio.getApiEnvironment();

  return env !== Environment.Prod;
};

export const allowDebugFeatureGuard = ({
  debugModeEnabled,
  isAdmin,
}: {
  debugModeEnabled: boolean;
  isAdmin?: boolean;
}) => {
  if (!debugModeEnabled) {
    return false;
  }

  if (isNotProduction()) {
    // allow for all
    return true;
  }

  // only allow for admins in production
  return isAdmin === true;
};
